import axios from "../axios"

const menuApi = {
	addMenu(data) {
		return axios({
			url: `/gzeua/Menu/CreateOrEdit`,
			method: "post",
			data
		})
	},
	
	deleteMenu(id) {
		return axios({
			url: `/gzeua/Menu/Delete`,
			method: "post",
			params:{id}
		})
	},
	
	getMenuTree() {//查询所有菜单
		return axios({
			url: `/gzeua/Menu/GetMenuTree`,
			method: "post",
		})
	},
	getUserMenuList() { //查询用户菜单
		return axios({
			url: `/gzeua/Menu/GetUserMenuList`,
			method: "post",
		})
	},
	getUserMenuTree() { //查询用户菜单树
		return axios({
			url: `/gzeua/Menu/GetUserMenuTree`,
			method: "post",
		})
	},

}
export default menuApi